module.exports = __webpack_public_path__ + "img/time-funnel_yellow.36363322.png";